import * as React from "react";
import type { Analysis } from "@/data/types";
import { Reveal, Overline } from "./primitives";
import { ObservationCard } from "./ObservationCard";

interface Props {
  analysis: Analysis;
}

export const AnalysisSection: React.FC<Props> = ({ analysis }) => {
  if (!analysis?.observations?.length) return null;

  const headline =
    analysis.overallObservation ||
    "The opportunity is in the positioning, not just the exposure.";

  return (
    <section
      className="w-full bg-ivory-alt py-20 md:py-28"
      data-testid="analysis-section"
      aria-label="What I noticed"
    >
      <div className="mx-auto w-full max-w-5xl px-6 md:px-10">
        <Reveal>
          <Overline>What I noticed</Overline>
          <h2 className="mt-4 max-w-2xl font-serif text-3xl leading-tight text-charcoal md:text-4xl lg:text-5xl">
            {headline}
          </h2>
        </Reveal>

        <Reveal delay={0.05}>
          <ul className="mt-12 border-b border-charcoal/10">
            {analysis.observations.map((o, i) => (
              <ObservationCard key={o.title} observation={o} index={i} />
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
